export default "__VITE_ASSET__741d2011__"